import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntUnitMeasurement } from "../../../../models/handBooks/unitMeasurement";
import { useAddUnitMeasurementMutation, useDeleteUnitMeasurementMutation, useEditUnitMeasurementMutation } from "../../../../redux/api/handBooksApi/unitMeasurementApi";
import { getCookie } from "typescript-cookie";


const useUnitMeasurement = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addUnitMeasurement] = useAddUnitMeasurementMutation();
    const [deleteUnitMeasurement] = useDeleteUnitMeasurementMutation();
    const [editUnitMeasurement] = useEditUnitMeasurementMutation();


    async function onAddUnitMeasurement(newUnitMeasurement: EntUnitMeasurement): Promise<boolean> {
        try {
            let status: boolean = false;
            await addUnitMeasurement(newUnitMeasurement).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteUnitMeasurement(unitMeasurement: EntUnitMeasurement) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteUnitMeasurement(unitMeasurement.id).then((response: any) => {
                          if (response.error) {
                                                      const isKyrgyz = getCookie('i18next') === 'ky';
                                                      const lang = isKyrgyz ? 'kg' : 'ru';
                                                      const res = response.error.data?.res;
                                                      const errorMessages = Array.isArray(res)
                                                          ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                          : response.error.data?.msg || t('unknownError'); 
                                                      throw new Error(errorMessages);
                                                  }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditUnitMeasurement(editedUnitMeasurement: EntUnitMeasurement): Promise<boolean> {
        try {
            let status: boolean = false;
            await editUnitMeasurement(editedUnitMeasurement).then((response: any) => {
                  if (response.error) {
                                              const isKyrgyz = getCookie('i18next') === 'ky';
                                              const lang = isKyrgyz ? 'kg' : 'ru';
                                              const res = response.error.data?.res;
                                              const errorMessages = Array.isArray(res)
                                                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                  : response.error.data?.msg || t('unknownError'); 
                                              throw new Error(errorMessages);
                                          }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddUnitMeasurement,onDeleteUnitMeasurement, onEditUnitMeasurement }

}
export { useUnitMeasurement };

